export const GET_SCREENERS = "GET_SCREENERS"
export const GET_SCREENERS_PENDING = "GET_SCREENERS_PENDING"
export const GET_SCREENERS_FULFILLED = "GET_SCREENERS_FULFILLED"
export const GET_SCREENERS_FAILED = "GET_SCREENERS_REJECTED"